import "core-js/stable";
import "regenerator-runtime/runtime";

import "core-js/es/set";
import "core-js/es/map";
import "raf/polyfill";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import "./index.css";

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { BrowserRouter } from "react-router-dom";

import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const firebaseConfig = {
  apiKey: "AIzaSyDELM4XUwCQ_Wcbid1sb7OuAtj4a3GN6Us",
  authDomain: "ny-gaume.firebaseapp.com",
  databaseURL: "https://ny-gaume.firebaseio.com",
  projectId: "ny-gaume",
  storageBucket: "ny-gaume.firebasestorage.app",
  messagingSenderId: "108342301353",
  appId: "1:108342301353:web:33c3cc7e3b340624",
  measurementId: "G-Y1EWNF3CJB",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

console.log(analytics.app.name);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();